import { Grid, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { BatchHeaderActions } from "./BatchHeaderActions";

interface IBatchActionHeader {
    setOpen: (set: boolean) => void;
}

export const BatchActionHeader : React.FC<IBatchActionHeader> = ({
    setOpen
}) => {

    const { t } = useTranslation();

    return (
        <Grid
            container
        >
            <Grid
                item
                xs={12}
                display="flex"
                justifyContent="space-between"
                marginBottom="8px"
            >
                <BatchHeaderActions 
                    setOpen={setOpen}
                />
            </Grid>
            <Grid
                item
                xs={12}
            >
                <Typography
                    fontWeight="600"
                    fontFamily="SEGOE UI"
                    fontSize="20px"
                    marginBottom="8px"
                >
                    {t("BatchActionModal.actionLabel")}
                </Typography>
                <Typography
                    fontFamily="segoe ui"
                    fontSize="14px"
                    color="#575757"
                >
                    {t("BatchActionModal.actionSublabel")}
                </Typography>
            </Grid>
        </Grid>
    )    
}